/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Reason/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Reason({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/EffectiveDate/Status/InfoTooltip/Content/Inactivated/Reason"
  
}) {
let constantData = 'Reason: '
let insuranceSubscriptionDeactivatedReasonValueData = fromData.useDataValue({ viewPath,
context: 'insurance_subscription',
path: 'deactivated_reason',
})
let aggregateData = fromAggregate.join(constantData, insuranceSubscriptionDeactivatedReasonValueData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="'Reason: '"
 data="insurance_subscription.deactivated_reason"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}